export enum EKeyboardKey {
  Backspace = 'Backspace',
  Comma = ',',
  Down = 'ArrowDown',
  End = 'End',
  Enter = 'Enter',
  Escape = 'Escape',
  Home = 'Home',
  Left = 'ArrowLeft',
  PageDown = 'PageDown',
  PageUp = 'PageUp',
  Right = 'ArrowRight',
  Space = ' ',
  Tab = 'Tab',
  Up = 'ArrowUp',
}

export enum EMenuAction {
  Close = 'Close',
  CloseSelect = 'CloseSelect',
  First = 'First',
  Last = 'Last',
  Next = 'Next',
  None = 'None',
  Open = 'Open',
  PageDown = 'PageDown',
  PageUp = 'PageUp',
  Previous = 'Previous',
  Select = 'Select',
  Space = 'Space',
}

interface IMenuSeparatorItem {
  hidden?: boolean;
  separatorBefore?: boolean;
  separatorAfter?: boolean;
}

export const hasMenuSeparatorBefore = (items: IMenuSeparatorItem[], index: number): boolean => {
  const current = items[index];
  if (current.hidden) return false;

  for (let previousIndex = index - 1; previousIndex >= 0; previousIndex--) {
    const previous = items[previousIndex];
    if (!previous.hidden) return !!(previous.separatorAfter || current.separatorBefore);
  }
  return false;
};

/**
 * get a menu action from keypress
 */
export const getActionFromKey = (event: KeyboardEvent, menuOpen: boolean): EMenuAction => {
  const { key, altKey } = event;
  const openKeys = [
    EKeyboardKey.Down,
    EKeyboardKey.Up,
    EKeyboardKey.Enter,
    EKeyboardKey.Space,
    EKeyboardKey.Home,
    EKeyboardKey.End,
  ]; // all keys that will open the menu

  // handle opening when closed
  if (!menuOpen && openKeys.includes(key as EKeyboardKey)) {
    return EMenuAction.Open;
  }

  // handle keypress when open
  if (menuOpen) {
    if ((key === EKeyboardKey.Down && !altKey) || key === EKeyboardKey.Right) {
      return EMenuAction.Next;
    } else if (key === EKeyboardKey.Up && altKey) {
      return EMenuAction.CloseSelect;
    } else if (key === EKeyboardKey.Up || key === EKeyboardKey.Left) {
      return EMenuAction.Previous;
    } else if (key === EKeyboardKey.Home) {
      return EMenuAction.First;
    } else if (key === EKeyboardKey.End) {
      return EMenuAction.Last;
    } else if (key === EKeyboardKey.PageUp) {
      return EMenuAction.PageUp;
    } else if (key === EKeyboardKey.PageDown) {
      return EMenuAction.PageDown;
    } else if (key === EKeyboardKey.Escape) {
      return EMenuAction.Close;
    } else if (key === EKeyboardKey.Enter) {
      return EMenuAction.CloseSelect;
    } else if (key === EKeyboardKey.Space) {
      return EMenuAction.Space;
    }
  }

  return EMenuAction.None;
};

/**
 * ensure given child element is within the parent's visible scroll area
 */
export const maintainScrollVisibility = (activeElement: HTMLElement, scrollParent: HTMLElement): void => {
  const { offsetHeight, offsetTop } = activeElement;
  const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;

  const isAbove = offsetTop < scrollTop;
  const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

  if (isAbove) {
    scrollParent.scrollTo(0, offsetTop);
  } else if (isBelow) {
    scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
  }
};
